var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useForm } from "react-hook-form";
import { Stack } from "@mui/material";
import { MessageContent } from "../../Organisms/Messages/Molecules";
import { Text, ButtonV2 } from "../../Atoms";
import HookTextField from "../../Molecules/HookInputs/HookTextField";
var ResetPassword = function (_a) {
    var submitForm = _a.submitForm;
    var _b = useForm({
        criteriaMode: "all",
        mode: "all",
    }), control = _b.control, handleSubmit = _b.handleSubmit, isValid = _b.formState.isValid, reset = _b.reset, getValues = _b.getValues;
    var onSubmit = function (data) {
        submitForm(data);
        reset({ password: "", passwordConfirmation: "" });
    };
    return (_jsx(MessageContent, __assign({ title: "Reset Password" }, { children: _jsxs(Stack, __assign({ direction: "column", spacing: 6, pt: 2 }, { children: [_jsx(Text, __assign({ variant: "body1", sx: { textAlign: "center" } }, { children: "Enter a new password. Must be at least 10 characters and contain at least 1 letter and 1 number." })), _jsxs("form", __assign({ onSubmit: handleSubmit(onSubmit) }, { children: [_jsxs(Stack, __assign({ spacing: 6 }, { children: [_jsx(HookTextField, { name: "password", variant: "outlined", label: "Password", id: "password", masked: true, validationArr: ["oneLetterOneNumber"], rules: {
                                        minLength: {
                                            value: 10,
                                            message: "Your password must be at least 10 characters long.",
                                        },
                                        required: {
                                            value: true,
                                            message: "You are required to create a password.",
                                        },
                                    }, control: control, sx: { width: "100%" } }), _jsx(HookTextField, { name: "passwordConfirmation", variant: "outlined", label: "Confirm Password", id: "passwordConfirmation", masked: true, rules: {
                                        validate: {
                                            matchesPassword: function (value) {
                                                return value === getValues("password") ||
                                                    "Password confirmation does not match newly entered password.";
                                            },
                                        },
                                        required: {
                                            value: true,
                                            message: "Password confirmation does not match newly entered password.",
                                        },
                                    }, control: control, sx: { width: "100%" } })] })), _jsx(ButtonV2, __assign({ sx: {
                                mt: 11,
                                width: "100%",
                            }, "data-testid": "button-reset-password", size: "small", type: "submit", disabled: !isValid }, { children: "Reset Password" }))] }))] })) })));
};
export default ResetPassword;
